import { DexFieldWidthEnumType, UserProfileView } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { DexFormModel, DexInquiry } from '../types';
import { formatName } from '../utils';
import { ATTENTION_MAX_LENGTH } from './constants';

export const widthsToPercentageValues: Record<DexFieldWidthEnumType, string | undefined> = {
    FULL: '100%',
    MEDIUM: '45%',
    SMALL: '20%',
};

export const widthsToMinimumValues: Record<DexFieldWidthEnumType, string | undefined> = {
    FULL: undefined,
    MEDIUM: '150px',
    SMALL: '110px',
};

export function getDexAttentionValue(
    form: UseFormReturn<DexFormModel<DexInquiry>>,
    dexRegion: string | undefined,
    userProfileView: UserProfileView
) {
    let attention = form.getValues('params.attention');
    const requestingUserOption = form.getValues('requestingUserOption');

    if (dexRegion === 'LA_LLETS') {
        attention = requestingUserOption ? requestingUserOption.label : formatName(userProfileView);
        // truncate to pass server validation since user doesn't have control over this value
        return attention.substring(0, ATTENTION_MAX_LENGTH);
    }

    return attention;
}
